import { LitElement, html, svg } from 'lit';

export class IconEyeOn16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Øye</title><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1 8C3.333 5.062 9 .7 15 8c-2.178 2.938-8 7.3-14 0Z"></path><circle cx="8" cy="8" r="1.8" fill="currentColor"></circle></svg>`; }
}
if (!customElements.get('f-icon-eye-on16', IconEyeOn16)) {
  customElements.define('f-icon-eye-on16', IconEyeOn16);
}